import { CourtFeeInvoicesSagas } from "./CourtFeeInvoices";

export default [...CourtFeeInvoicesSagas];
